var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionDrawingPinDisable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m22.707 21.293-1.414 1.414L13.586 15H13v6l-1 1-1-1v-6H6v-2l2-3v-.586L1.293 2.707l1.414-1.414 20 20ZM9.664 11.109 8.404 13h3.182l-1.91-1.91-.012.02Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4h-1v6l2 3v.879l-4-4V4h-4v1.879l-3-3V2h10v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionDrawingPinDisable);
export default __webpack_public_path__ + "static/media/ic_action_drawing_pin_disable.2008e7c02c10647659efef06c412d872.svg";
export { ForwardRef as ReactComponent };